import { matchPath } from 'react-router-dom';

export const useRouteIsMatching = (path: string): boolean =>
  Boolean(matchPath({ path, end: true }, location.pathname));
